export { default as Component } from "./TimeSeries.svelte";
export const modes = ["static", "dynamic"];
